@if (isLoading) {
  <div class="power-bi-loading">Loading report...</div>
}
@if (errorMessage) {
  <div class="power-bi-error">{{ errorMessage }}</div>
}
<div #reportContainer class="power-bi-container"></div>
